import { Component, input } from '@angular/core';
import {NgIf} from '@angular/common';
import {RouterModule} from '@angular/router';

@Component({
    selector: 'app-breadcrumbs',
    imports: [
        NgIf,
        RouterModule
    ],
    templateUrl: './breadcrumbs.component.html',
    styleUrls: ['./breadcrumbs.component.scss']
})
export class BreadcrumbsComponent {
  readonly type = input<string>(undefined);
}
